import CustomDayPickerCaption from './CustomDayPickerCaption';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import { ArrowsStackedIcon } from '../Icons';
import { t, getLocale } from '../i18n';
import { CustomDayPickerDayContent } from './CustomDayPickerDayContent';

/**
 * The default formatter for the Month caption.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function formatMonthCaption(month, options) {
  return format(month, 'LLL', options);
}
export function CustomDayPicker(props) {
  return /*#__PURE__*/_jsx(DayPicker, {
    locale: getLocale(),
    mode: "single",
    footer: /*#__PURE__*/_jsx("span", {
      className: "ds-u-visibility--screen-reader",
      children: t('singleInputDateField.arrowKeyInstructions')
    }),
    captionLayout: "dropdown",
    components: {
      Caption: CustomDayPickerCaption,
      IconDropdown: ArrowsStackedIcon,
      DayContent: CustomDayPickerDayContent
    },
    formatters: {
      formatMonthCaption
    },
    ...props
  });
}
export default CustomDayPicker;